
export function getCurrentYear() {
  return new Date().getFullYear();
}